import { useState, type FormEvent } from 'react';
import { useAuth } from '../auth/AuthContext';
import { BladApi } from '../api/client';
import { Komunikat, Pole, Przycisk } from '../components/ui';

export function Logowanie() {
  const { zaloguj } = useAuth();
  const [login, setLogin] = useState('');
  const [haslo, setHaslo] = useState('');
  const [blad, setBlad] = useState<string | null>(null);
  const [wysylanie, setWysylanie] = useState(false);

  async function wyslij(e: FormEvent) {
    e.preventDefault();
    setBlad(null);
    setWysylanie(true);
    try {
      await zaloguj(login.trim(), haslo);
    } catch (err) {
      setBlad(err instanceof BladApi ? err.message : 'Logowanie się nie powiodło.');
      setHaslo('');
    } finally {
      setWysylanie(false);
    }
  }

  return (
    <main className="flex min-h-screen items-center justify-center bg-kamien-100 px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <p className="text-xs font-medium uppercase tracking-widest text-bordo-600">
            Collegium Medicum · Akademia WSB
          </p>
          <h1 className="mt-2 text-2xl font-semibold text-kamien-900">Magazyn CSM</h1>
          <p className="mt-1 text-sm text-kamien-500">
            Centrum Symulacji Medycznych im. prof. Kazimierza Imielińskiego
          </p>
        </div>

        <form
          onSubmit={wyslij}
          className="flex flex-col gap-4 rounded-lg bg-white p-6 ring-1 ring-kamien-200"
        >
          {blad && <Komunikat rodzaj="blad">{blad}</Komunikat>}

          <Pole
            etykieta="Login"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            autoComplete="username"
            autoFocus
            required
          />
          <Pole
            etykieta="Hasło"
            type="password"
            value={haslo}
            onChange={(e) => setHaslo(e.target.value)}
            autoComplete="current-password"
            required
          />

          <Przycisk type="submit" wariant="glowny" disabled={wysylanie} className="mt-2">
            {wysylanie ? 'Logowanie...' : 'Zaloguj'}
          </Przycisk>

          <p className="text-center text-xs text-kamien-500">
            Konto zakłada administrator. Zgubione hasło resetuje administrator —
            nie da się go odzyskać, bo w bazie nie ma go w czytelnej postaci.
          </p>
        </form>
      </div>
    </main>
  );
}
